<script lang="ts" module>
  import type { Product } from "@agapi/mlc-core";

  export interface ProductFooterProps {
    product: Product;
    stock?: number;
  }
</script>

<script lang="ts">
  import { page } from '$app/state';

  import { css } from "@agapi/ui/panda/css";
  import { Section } from "@agapi/ui/section";

  import * as m from '$lib/parachute/messages';

  const { product, stock }: ProductFooterProps = $props();

  let variant = $derived(product.variants[0]);
</script>

<Section containerWidth="tight" containerStyles={css.raw({ alignItems: "center" })}>
  <!-- Lip Score Reviews -->
  <h2 class={css({ color: "text.heading" })}>{m.reviews()}</h2>
  {#key product.handle}
    <div id="lipscore-review-list"
      data-ls-product-name={product.name}
      data-ls-brand={product.brand.name}
      data-ls-product-id={product.id}
      data-ls-product-url={page.url.toString()}
      data-ls-variant-id={variant.id}
      data-ls-variant-name={variant.name}
      data-ls-sku={variant.sku}
      data-ls-description={product.description.short}
      data-ls-image-url={variant.images[0].url}
      data-ls-price={(variant.price.amount / 100).toString()}
      data-ls-price-currency={variant.price.currency}
      data-ls-availability={stock?.toString()}
      data-ls-page-size="10">
    </div>
  {/key}
</Section>
